import React from 'react';

interface WestfalenLogoProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg';
}

const WestfalenLogo: React.FC<WestfalenLogoProps> = ({ className = '', size = 'md' }) => {
  const sizeClasses = {
    sm: 'h-8 w-8',
    md: 'h-12 w-12',
    lg: 'h-16 w-16'
  };

  return (
    <div className={`${sizeClasses[size]} ${className} westfalen-logo`}>
      <svg
        viewBox="0 0 100 100"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="w-full h-full"
      >
        {/* Westfalen Pferd Logo - verbesserte Darstellung */}
        {/* Körper */}
        <path
          d="M15 70 Q25 60 35 70 Q45 80 55 70 Q65 60 75 70 Q85 80 90 70"
          stroke="#1e3a8a"
          strokeWidth="4"
          fill="none"
          strokeLinecap="round"
        />
        {/* Pferdekopf */}
        <path
          d="M85 70 Q90 60 95 70 Q97 80 95 85 Q90 90 85 85 Q83 80 85 70"
          stroke="#1e3a8a"
          strokeWidth="4"
          fill="none"
          strokeLinecap="round"
        />
        {/* Beine */}
        <path
          d="M25 70 L25 90 M45 70 L45 90 M65 70 L65 90"
          stroke="#1e3a8a"
          strokeWidth="3"
          strokeLinecap="round"
        />
        {/* Schwanz */}
        <path
          d="M15 70 Q10 60 5 70"
          stroke="#1e3a8a"
          strokeWidth="3"
          fill="none"
          strokeLinecap="round"
        />
        {/* Mähne */}
        <path
          d="M75 70 Q80 60 85 70"
          stroke="#1e3a8a"
          strokeWidth="2"
          fill="none"
          strokeLinecap="round"
        />
        {/* Auge */}
        <circle
          cx="92"
          cy="75"
          r="2"
          fill="#1e3a8a"
        />
        {/* Nase */}
        <circle
          cx="97"
          cy="80"
          r="1"
          fill="#1e3a8a"
        />
      </svg>
    </div>
  );
};

export default WestfalenLogo;
